export const filter = {
    id: "",
    name: "",
    state_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
